import React from 'react'
import financial from './helloworld.png'
const Profits = () => {
    return (
        <div className='py-5 px-md-5 container-fluid'>
            <h1 style={{fontWeight:400}} className="display-4 text-light">Start Getting Profit in 3 Simple Steps        </h1>
            <h4 style={{fontWeight:300}} className=" text-light">Follow these 3 simple steps to start earning passive income with VTC!</h4>
            <div className="row">
                <div className="justify-content-md-center col-12 col-md-6">
                    <div className="my-5 card rounded-4" style={{backgroundColor:"#23153c",borderColor:"#ffff"}}>
                        <div className="row p-2">
                            <div className="justify-content-md-center col-12 col-md-2 d-flex py-2">
                                
                                    <div className="d-flex align-items-center rounded-circle border border-light">
                                    <i class="fa-solid fa-1 px-3 px-md-4 py-2 text-light"></i>
                                    </div>
                                
                            </div>
                            <div className="justify-content-md-center col-12 col-md-10 py-2">
                                <h6 className='text-light'>
                                Create Your Account
                                </h6>
                                <p className='text-light'>Get started by contacting our team for registration.</p>
                                      </div>
                        </div>
                    </div>
                    <div className="my-5 card rounded-4" style={{backgroundColor:"#23153c",borderColor:"#ffff"}}>
                        <div className="row p-2">
                            <div className="justify-content-md-center col-12 col-md-2 d-flex py-2">
                                
                                    <div className="d-flex align-items-center rounded-circle border border-light">
                                    <i class="fa-solid fa-2 px-3 px-md-4 py-2 text-light"></i>
                                    </div>
                                
                            </div>
                            <div className="justify-content-md-center col-12 col-md-10 py-2">
                                <h6 className='text-light'>
                                Invest in Your Future
                                </h6>
                                <p className='text-light'>Enjoy 0.4% daily profits and unlock bonus rewards</p>
                                      </div>
                        </div>
                    </div>
                    <div className="my-5 card rounded-4" style={{backgroundColor:"#23153c",borderColor:"#ffff"}}>
                        <div className="row p-2">
                            <div className="justify-content-md-center col-12 col-md-2 d-flex py-2">
                                
                                    <div className="d-flex align-items-center rounded-circle border border-light">
                                    <i class="fa-solid fa-3 px-3 px-md-4 py-2 text-light"></i>
                                    </div>
                                
                            </div>
                            <div className="justify-content-md-center col-12 col-md-10 py-2">
                                <h6 className='text-light'>
                                Stake & Earn Rewards
                                </h6>
                                <p className='text-light'>Choose your staking plan & Earn Unlimited Rewards</p>
                                      </div>
                        </div>
                    </div>
                    <div className='my-5'>
                        <p className="text-light">
                        Withdraw anytime! No delays, no middlemen—your earnings are always yours.
                        </p>
                        <div className="justify-content-center d-flex">
                            <button className="btn btn-light rounded-5">Join VTC</button>
                        </div>
                    </div>
                </div>
                <div className="justify-content-md-center col-12 col-md-6">
                    <img src={financial} alt="" className="card-img-top rounded-4" />
                </div>
            </div>
        </div>
    )
}

export default Profits